import { cookieOptions } from '@brands/Utils/getToken';
import Cookies from 'js-cookie';

const clickIdNames = ['gclid', 'gbraid', 'wbraid'] as const;
const clickIdPattern = /^[A-Za-z0-9_.-]+$/;

// Share the cookies with the marketing site using the configured domain.
// A new value replaces only that ID; direct visits retain known attribution.
export function captureGoogleClickIds(search: string = window.location.search): void {
  const params = new URLSearchParams(search);
  const values = new Map<string, string>();
  params.forEach((value, key) => {
    values.set(key.toLowerCase(), value.trim());
  });

  clickIdNames.forEach((name) => {
    const value = values.get(name);
    if (value && clickIdPattern.test(value)) {
      Cookies.set(name, value, { ...cookieOptions(), path: '/', expires: 90 });
    }
  });
}

export function getGoogleClickIdHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  clickIdNames.forEach((name) => {
    const value = Cookies.get(name)?.trim();
    // Shared-domain cookies can be written outside this app. Reject malformed
    // values here so requests never forward an identifier altered by Axios.
    if (value && clickIdPattern.test(value)) headers[`x-${name}`] = value;
  });
  return headers;
}
